import { Stack, Card, CardHeader, CardContent, IconButton, Box } from '@mui/material';
import {
    BoxSpaceBetween,
} from '../style/box'
import { FONT_COLOR } from '../const/general'

export default function CommonCard(props) {
    return (
        <Card variant="outlined"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#000',
                width: '100%',
                height: '100%'
            }}>
            <CardHeader sx={{ padding: '3px' }}
                titleTypographyProps={{
                    sx: {
                        color: FONT_COLOR,
                        fontSize: {xs:'0.75rem',sm:'0.75rem', md:'clamp(0.375rem, -0.3rem + 1.2vw, 0.75rem)'},
                        fontWeight: 'bold',
                        backgroundColor: '#2f4f4f',
                        padding: '3px',
                    }  
                }}
                title={props.title}
            />
            <CardContent
                sx={{
                    flex: 1, // ← これで残り全部使う
                    overflow: 'hidden', // はみ出し防止
                    padding: '0 5px',
                    '&:last-child': {
                        paddingBottom: '5px',
                    }
                }}
            >
                <Box
                    sx={{
                        boxSizing: 'border-box',
                        // height: '100%'
                        height: { xs: props.xsHeight, sm: props.height }
                    }}>
                    {props.child}
                </Box>
            </CardContent>
        </Card>
    )
};
